import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Button,
  Paper
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";

const VerifyEmail = () => {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState("loading"); // success | error
  const [message, setMessage] = useState("");

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const verify = async () => {
      try {
        const token = new URLSearchParams(location.search).get("token");

        if (!token) {
          setStatus("error");
          setMessage("Token not found");
          return;
        }

        const res = await apiClient.get(`/api/vendor/verify-email?token=${token}`);

        if (res?.data?.success) {
          setStatus("success");
          setMessage(res?.data?.message);
        } else {
          setStatus("error");
          setMessage(res?.data?.message);
        }

      } catch (err) {
        setStatus("error");
        setMessage(err?.response?.data?.message || "Verification failed");
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [location]);

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 400, textAlign: "center" }}>

        {loading ? (
          <>
            <CircularProgress />
            <Typography mt={2}>Verifying...</Typography>
          </>
        ) : (
          <>
            <Typography
              variant="h6"
              color={status === "success" ? "green" : "error"}
              fontWeight="bold"
            >
              {status === "success" ? "Success 🎉" : "Error ❌"}
            </Typography>

            <Typography mt={2}>{message}</Typography>

            <Button
              variant="contained"
              sx={{ mt: 3 }}
              onClick={() => navigate("/")}
            >
              Go To Home
            </Button>
          </>
        )}

      </Paper>
    </Box>
  );
};

export default VerifyEmail;